import React from 'react'
// libs
import styled from 'styled-components'
// components
import { IconButton } from 'components/UI'
// static
import ArchiveIconOrigin from 'src/icons/archive.svg'
// utils
import { size } from 'polished'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'

const ArchiveIcon = styled(ArchiveIconOrigin)`
  && {
    ${size('24px')};
  }
`

const ShowArchivedPlanItemsButton: React.FC = () => {
  const { showArchivedPlanItems, toggleShowArchivedPlanItems } = React.useContext(PlanEditPageContext)

  return (
    <IconButton
      onClick={toggleShowArchivedPlanItems}
      isActive={showArchivedPlanItems}
      description={showArchivedPlanItems ? 'Show Active Items' : 'Show Archived Items'}>
      <ArchiveIcon />
    </IconButton>
  )
}

export default ShowArchivedPlanItemsButton
